export function googleAdGetQuote() {
  // google code
  setTimeout(
    () =>
      // eslint-disable-next-line no-undef
      gtag('event', 'conversion', {
        send_to: 'AW-16613834008/tiIRCNiDjbsZEJj6i_I9',
      }),
    500,
  );
}

export function googleAdPaidOrder(data) {
  console.log('googleAdPaidOrder', data);
  // google code
  setTimeout(
    () =>
      // eslint-disable-next-line no-undef
      gtag('event', 'conversion', {
        send_to: 'AW-16613834008/5llFCMyombsZEJj6i_I9',
        value: data.orderNum,
        currency: 'USD',
        transaction_id: data.orderNum,
      }),
    500,
  );
}

export function googleAdCreateOrder(money) {
  console.log('googleAdCreateOrder', money);
  // google code
  setTimeout(
    () =>
      // eslint-disable-next-line no-undef
      gtag('event', 'conversion', {
        send_to: 'AW-16613834008/b96xCNHA6LsZEJj6i_I9',
        value: money,
        currency: 'USD',
      }),
    500,
  );
}
